import isNil from 'lodash/isNil';
import { CircleAlertIcon, TriangleAlertIcon } from 'lucide-react';
import { type ReactNode } from 'react';

import { Alert as AlertRoot, AlertDescription, AlertTitle, AlertVariant } from '@ui/components/base/alert';
import { cn } from '@ui/lib/utils';

interface AlertProps {
  title?: ReactNode;
  children?: ReactNode;
  variant?: AlertVariant;
  icon?: ReactNode;
  className?: string;
}

const defaultIconByVariant: Partial<Record<AlertVariant, ReactNode>> = {
  [AlertVariant.DESTRUCTIVE]: <CircleAlertIcon />,
  [AlertVariant.WARNING]: <TriangleAlertIcon />,
};

const Alert = ({ title, children, variant = AlertVariant.DEFAULT, icon, className }: AlertProps) => (
  <AlertRoot
    variant={variant}
    className={cn(isNil(title) && 'items-center *:[svg]:row-span-1 *:[svg]:translate-y-0', className)}
  >
    {icon ?? defaultIconByVariant[variant]}
    {title && <AlertTitle>{title}</AlertTitle>}
    {children && <AlertDescription>{children}</AlertDescription>}
  </AlertRoot>
);

export { Alert, AlertVariant };
export type { AlertProps };
